import { Card, Divider, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddCircle';
import DeleteIcon from '@material-ui/icons/DeleteForever';
import InvitationsIcon from '@material-ui/icons/InsertLink';
import LockIcon from '@material-ui/icons/LockOpen';
import {
  Form,
  Row
} from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { change, Field, FieldArray, reduxForm, submit } from 'redux-form';
import { PERMISSION_ENTITIES, PERMISSIONS, RED } from '../../_config/consts.js';
import { elaborateForbiddenDaysString, hasFormWritePermission } from '../../_config/utils.js';
import AbilityProvider from '../../permissionsUtils/AbilityProvider.js';
import MDButton from '../MDButton/MDButton.jsx';
import FormFlatContainer from './Elements/FormFlatContainer.jsx';
import InvitationsTimeSelector from './Elements/InvitationsTimeSelector.jsx';
import LocksSelectorField from './Elements/LocksSelectorField.jsx';
import MDRadioButtonsGroupField from './Elements/MDRadioButtonsGroup/MDRadioButtonsGroupField.js';
import CustomField from './Fields/CustomField.jsx';

const onRenderNotificationEmails = (props) => {
  const { fields, formData, onInitializeNewEmail } = props;
  const numberOfEmails = _.size(fields);
  return (
    <div style={{}}>
      {fields && _.map(fields, (email, index) => (
        <div key={`email${index + 1}`} style={{ width:'fit-content' }}>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: -10, paddingRight: 10 }}>
            <Row style={{marginLeft:0, marginRight:0 }}>
              <div style={{ paddingLeft: 0, width: 400 }}>
                <Entity
                  id={`emails[${index}]`}
                  name={`emails[${index}]`}
                  componentClass={Field}
                  componentAttribute="placeholder"
                  entity="insertEmail"
                  title={null}
                  component={CustomField}
                />
              </div>
            </Row>
            <IconButton
              style={{ marginBottom: 10 }}
              disabled={props.disabled}
              onClick={(e) => {
                e.stopPropagation();
                if (!formData.isEditing) {
                  fields.remove(index);
                }
              }}
            >
              <DeleteIcon style={{ color: RED, fontSize: 20 }} />
            </IconButton>
          </div>
        </div>
      ))}
      {!props.disabled ? (
        <Card
          style={{ height: 35, marginBottom: 20, padding: 10, display: 'flex', flexDirection: 'row', alignItems: 'center', width:'fit-content' }}
          className="card card-rounded"
          onClick={() => {
            fields.push({});
            onInitializeNewEmail(numberOfEmails);
          }}
        >
          <AddIcon style={{ color: '#4DB6AC', marginRight: 15, fontSize: 20 }} />
          <h4 style={{ fontWeight: 'bold', marginTop: 0, marginBottom: 1, fontSize: 16 }}><Entity entity="newResourceReservationAutomaticEmail" /></h4>
        </Card>
      ) : null}
    </div>
  );
}

const validate = (values) => {
  const errors = {};
  if (values) {
    if (!values.name) {
      errors.name = 'required';
    }
    
    if (!values.guestTags || (values.guestTags && _.isEmpty(values.guestTags))) {
      errors.guestTags = 'required';
    }

    if (values.numberOfDevices === undefined) {
      errors.numberOfDevices = 'required';
    }

    if (!values.lockTags || (values.lockTags && _.isEmpty(values.lockTags))) {
      errors.lockTags = 'required';
    }

    if (!values.credentialTimeframe || !values.credentialTimeframe.startDate || !values.credentialTimeframe.endDate) {
      errors.credentialTimeframe = 'reservationDateIntevalErrorMessage';
    }

    if (!values.timeIntervalFrom) {
      errors.timeIntervalFrom = 'required';
    }

    if (!values.timeIntervalTo) {
      errors.timeIntervalTo = 'required';
    }
    if (values.timeIntervalTo && values.timeIntervalFrom) {
      const toTime = moment(values.timeIntervalTo);
      const fromTime = moment(values.timeIntervalFrom);
      const toDate = moment(0).hour(toTime.hour()).minute(toTime.minute()).second(0);
      const fromDate = moment(0).hour(fromTime.hour()).minute(fromTime.minute()).second(0);
      if (toDate.isSameOrBefore(fromDate)) {
        errors.timeIntervalTo = 'Interval not valid';
      }
    }
  }

  return errors;
};

@reduxForm({ form: 'InvitationForm', validate })
@connect(state => ({ form: state.form.InvitationForm, companyConfigurations: state.user.companyConfigurations }))
class InvitationForm extends React.Component {

  onInitializeNewEmail(emailId, fieldName) {
    const { dispatch } = this.props;
    dispatch(change('InvitationForm', `emails[${emailId}]`, ''));
  }

  componentDidMount() {
    const { form, onLockTagsChange } = this.props;
    const isEditing = form && form.values && form.values.id;
    // Handle smart lock fields initialization on edit mode
    if (isEditing) {
      onLockTagsChange();
    }
  }
 
  render() {
    const {
      form,
      availableLockTags,
      onLockTagsChange,
      onLockFilterModeChange,
      onLockInputChange,
      onFetchMoreLocks,
      onDeleteCredential,
      dispatch,
      companyConfigurations,
    } = this.props;
    const isEditing = form && form.values && form.values.id;
    const canReadLock = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.READ], PERMISSION_ENTITIES.SMART_LOCK);
    const canCreateItem = AbilityProvider.getAbilityHelper().hasPermission([PERMISSIONS.ALL], PERMISSION_ENTITIES.INVITATION);
    const validityDateFrom = form && form.values && form.values.validityDateFrom;
    const validityDateTo = form && form.values && form.values.validityDateTo;
    const validityTimeFrom = form && form.values && form.values.validityTimeFrom;
    const validityTimeTo = form && form.values && form.values.validityTimeTo;
    const timeIntervalTo = form && form.values && form.values.timeIntervalTo;
    const timeIntervalFrom = form && form.values && form.values.timeIntervalFrom;
    const daysString = form && form.values && form.values.daysOfTheWeek && elaborateForbiddenDaysString(form.values.daysOfTheWeek) ? elaborateForbiddenDaysString(form.values.daysOfTheWeek) : '';
    const smartLocksSelected = form && form.values && form.values.selectedLocks;
    const formData = form && form.values;
    const deviceNumberOptions = [
      {
        label: <Entity entity="oneDevice" />,
        value: 1,
      },
      {
        label: <Entity entity="numberOfDevice" data={{ number: 2 }} />,
        value: 2,
      },
      {
        label: <Entity entity="numberOfDevice" data={{ number: 3 }} />,
        value: 3,
      },
      {
        label: <Entity entity="numberOfDevice" data={{ number: 4 }} />,
        value: 4,
      },
    ];
    if (companyConfigurations && companyConfigurations.infiniteDevicesInvitation) deviceNumberOptions.push({ label: <Entity entity="unlimited" />, value: 0 });
    return (
      <Form>
        {isEditing ? null : (
          <FormFlatContainer
            headerStyle={{ marginBottom: 20 }}
            title="invitationDetails"
            icon={<InvitationsIcon style={{ fontSize: 22, marginTop: 2, marginRight: 2 }} />}
            containerStyle={{ marginRight: 10, marginTop: 5 }}
          >
            <Entity
              componentClass={Field}
              name="name"
              componentAttribute="placeholder"
              entity="invitationNameDescription"
              title={<Entity entity="invitationName" />}
              component={CustomField}
              type="text"
              mandatory
            />
            <Divider style={{ marginTop: 20, marginBottom: 20 }} />
            <div style={{ marginTop: 10 }}>
              <h4 style={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold' }}>{<Entity entity="numberOfAuthorizedDevicesTitle" />}</h4>
              <h4 style={{ fontSize: 14, color: '#3f3f3f' }}>{<Entity entity="numberOfAuthorizedDevicesSubtitle" />}</h4>
              <Field
                name="numberOfDevices"
                title={<Entity entity="daysOfTheWeek" />}
                component={MDRadioButtonsGroupField}
                // onHandleChange={values => this.onProgramTypeSelected(values, 1)}
                containerstyle={{ paddingLeft: 15, marginTop: 0 }}
                horizontal
                showErrorLabel
                options={deviceNumberOptions}
              />
            </div>
            <Divider style={{ marginTop: 10, marginBottom: 20 }} />
            <div style={{ marginTop: 10 }}>
              <h4 style={{ fontSize: 16, color: '#3f3f3f', fontWeight: 'bold' }}>{<Entity entity="invitationAutomaticEmailsTitle" />}</h4>
              <h4 style={{ fontSize: 14, color: '#3f3f3f' }}>{<Entity entity="invitationAutomaticEmailsDescription" />}</h4>
              <FieldArray
                name="emails"
                component={onRenderNotificationEmails}
                formData={formData}
                form={form}
                onInitializeNewEmail={emailId => this.onInitializeNewEmail(emailId)}
              />
            </div>
          </FormFlatContainer>
        )}
        <FormFlatContainer
          title="credentialLockTitle"
          subtitle="invitationTagLockSubtitle"
          icon={<LockIcon style={{ fontSize: 22, marginTop: 2, marginRight: 2 }} />}
          containerStyle={{ marginRight: 10 }}
        >
          <LocksSelectorField
            name="lockTags"
            selectedTagsFieldName="selectedLocks"
            formName="InvitationForm"
            tags={availableLockTags}
            selectedTags={smartLocksSelected}
            form={form}
            tagsType="LOCK"
            title="searchForLocks"
            placeholder="insertLockTagsForCredential"
            hideBottomSelectionSection
            selectionSectionTitle="invitationSelectedLocksTitle"
            selectionSectionSubtitle="invitationSelectedLocksSubtitle"
            listTitle="selectedLocks"
            emptyTagSelectionText={canReadLock ? 'noLocksSelectedWithTag' : null}
            onFetchMoreItems={page => onFetchMoreLocks(page)}
            onTagsChange={values => onLockTagsChange(values)}
            onInputChange={value => onLockInputChange(value)}
            onFilterModeChange={values => onLockFilterModeChange(values)}
            disabled={!hasFormWritePermission(PERMISSION_ENTITIES.CREDENTIAL_RULE, isEditing)}
            />
          </FormFlatContainer>
        <InvitationsTimeSelector
          formName="InvitationForm"
          validityDateFrom={validityDateFrom}
          validityDateTo={validityDateTo}
          validityTimeFrom={validityTimeFrom}
          validityTimeTo={validityTimeTo}
          timeIntervalTo={timeIntervalTo}
          timeIntervalFrom={timeIntervalFrom}
          daysString={daysString}
          canEdit={true}
        />
        <MDButton
          title={<Entity entity="save" />}
          containerStyle={{ position: 'absolute', left: 0, right: 0, bottom: 0, width: '100%', margin: 0 }}
          style={{ height: 45, borderRadius: 0 }}
          onClick={() => dispatch(submit('InvitationForm'))}
        />
      </Form>
    );
  }
} 

export default InvitationForm;
